import { render, staticRenderFns } from "./ServiceCollapse.vue?vue&type=template&id=97d8f23e"
import script from "./ServiceCollapse.vue?vue&type=script&lang=js"
export * from "./ServiceCollapse.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  
}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports